import { useSelector } from 'src/store';
import { clientPortalVersionSelector } from 'src/store/selectors/productInfoSelector';

function Footer() {
  const clientPortalVersion = useSelector(clientPortalVersionSelector);

  return (
    <footer className="py-5">
      <p className="is-size-5 has-text-centered">{`DataHub v${clientPortalVersion}`}</p>
    </footer>
  );
}

export default Footer;
